import styled from "styled-components";

import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../constants/Styles";

export const textStyles = `
    text-decoration: none;
    color: ${COLORS.secondaryLight};
    font-size: ${FONT_SIZE.size14};
    font-weight: ${FONT_WEIGHT.weight500};
    line-height: 1rem;
    
    &:hover {
        color: ${COLORS.secondary};
    }
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap-reverse;
  padding: 0 1rem;
  gap: 2rem;
`;

export const SidebarElement = styled.div`
  width: 250px;
  padding-top: 1rem;
`;

export const SidebarTitle = styled.div`
  ${textStyles};
  font-size: ${FONT_SIZE.size24};
`;

export const SidebarList = styled.ol<{ useLeftMargin: boolean }>`
  list-style-type: none;
  padding-left: 0;

  ${({ useLeftMargin }) => useLeftMargin && `margin-left: 1rem;`}
`;

export const SidebarListItem = styled.li`
  margin: 1rem 0;

  > a {
    ${textStyles};
  }
`;

export const Body = styled.div`
  max-width: 650px;
`;
